import { ConfirmDialog } from "../shared/ConfirmDialog";

export const EliminarAtributoDialog = ({ visible, onCancel, onConfirm, atributo }) => (
    <ConfirmDialog
        visible={visible}
        onCancel={onCancel}
        onConfirm={onConfirm}
        header="Eliminar Atributo"
        message={`¿Realmente desea eliminar el atributo "${atributo?.llave || atributo?.nombre || ''}"? Esta acción no se puede deshacer.`}
    />
);